<template>
	<router-view></router-view>
</template>

<script>
	export default {
		name: "SettingsView",
	};
</script>

<style scoped>

</style>
